import Util from '@/util'

export function isColorLight(hex = '#313131') {
  if (hex === '') {
    hex = '#313131'
  }
  // Convert hex to RGB
  const { r, g, b } = Util.hexToRgb(hex)

  // Calculate relative luminance (per WCAG standards)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  // Return true if the color is light, false if dark
  return luminance > 0.5
}

export function isContrast(color1 = '#ffffff', color2 = '#000000') {
  // For more info: https://dev.to/alvaromontoro/building-your-own-color-contrast-checker-4j7o
  const hex1 = Util.hexToRgb(color1)
  const hex2 = Util.hexToRgb(color2)

  if (!hex1 || !hex2) return false
  const hexLuminance = Util.getColourLuminance(
    hex1.r,
    hex1.g,
    hex1.b,
  )
  const hex2Luminance = Util.getColourLuminance(
    hex2.r,
    hex2.g,
    hex2.b,
  )
  const contrastRatio = Util.getContrastRatio(
    hexLuminance,
    hex2Luminance,
  )

  // Question title font size's > 18px ( > 18pt) => AA-level passed when contrast < 1/3
  const AALevelPassedForLargeText = 1 / 3
  return contrastRatio < AALevelPassedForLargeText
}
